<div class="title">{{ title() }}</div>

@if (frames().length > 1) {
    <img
            class="image"
            [src]="$safeNavigationMigration(currentFrame()?.imageUrl)"
            [alt]="'asset_details.photos' | transloco"
    />
    <div class="overlay">
        <div class="timeline-meta">
            <span>{{ $safeNavigationMigration(currentFrame()?.capturedAt) | lorenDate }}</span>
            <span>{{ currentIndex() + 1 }} / {{ frames().length }}</span>
        </div>
        <mat-slider
                class="slider"
                [min]="0"
                [max]="maxIndex()"
                [step]="1"
                [discrete]="false">
            <input
                    matSliderThumb
                    [ngModel]="currentIndex()"
                    (ngModelChange)="onSliderChange($event)"/>
        </mat-slider>
    </div>
} @else {
    <div class="empty">
        <mat-icon>image_not_supported</mat-icon>
        <span>{{ "asset_details.no_data_yet" | transloco }}</span>
    </div>
}
